module.exports = __webpack_public_path__ + "img/MEDIA120.087afe8d.jpg";